"use client"

import { useSyncExternalStore } from "react"

import { subscribeViewerBoundary, viewerBoundaryGeneration } from "@/platform/session/viewer-boundary"

export const useViewerBoundary = (): number => useSyncExternalStore(subscribeViewerBoundary, viewerBoundaryGeneration, viewerBoundaryGeneration)
